module.exports = __webpack_public_path__ + "img/MGH-Nihonbashi-6.8dbba7fd.jpg";